import { storage } from './storage';

const getKey = (key: string): string => {
  return `__FEIMAAI__${key.toUpperCase()}__`;
};

const USER_KEY: string = getKey('userInfo');

function setCookie(key: string, val: string | null, expires: number) {
  let d = new Date();
  d.setDate(d.getDate() + expires);
  document.cookie = `${key}=${val};expires=${d}`;
}

/** 通过设置过期时间为 -1 天来删除 Cookie */
function removeCookie(key: string) {
  setCookie(key, null, -1);
}

/** 从 localStorage 读取用户信息（键名带 __FEIMAAI__ 前缀） */
export const getStorageUser = () => storage?.get(USER_KEY, {});

/**
 * 持久化用户信息到 localStorage，同时将 token 和 unionId 写入 Cookie（有效期 60 天）。
 * Cookie 供服务端或其他子域读取鉴权信息。
 */
export const setStorageUser = (v: any): void => {
  storage.set(USER_KEY, v);
  if (v) {
    setCookie('token', v.token || '', 60);
    setCookie('unionId', v.unionId || '', 60);
  }
};

/** 清除 localStorage 中的用户信息及对应的 token/unionId Cookie */
export const removeStorageUser = (): void => {
  storage.remove(USER_KEY);
  removeCookie('token');
  removeCookie('unionId');
};
